import "../styles/App.css";
import { useNavigate, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, message, Spin, Result, Card } from "antd";
import NumberSearch from "./NumberSearch";
import ReportDNC from "./ReportDNC";
import logo from "../Logo.png";
import { UI_SETTINGS_API_ENDPOINT } from "./Constants";
import config from "../config/config";
import ThemeToggle from "./ThemeToggle";

function App() {
    const navigate = useNavigate();

    const [uiSettings, setUiSettings] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchUiSettings() {
            const axios = require("axios").default;
            try {
                const response = await axios.get(UI_SETTINGS_API_ENDPOINT, {
                    headers: {
                        "Access-Control-Allow-Origin": "no-cors",
                        ApiKey: config.API_KEY, //INTERNAL_API_KEY,
                    },
                });
                const jsonResponse = response.data;

                if (!jsonResponse || Object.keys(jsonResponse).length === 0) {
                    message.error("Invalid ApiKey!");
                    setError("Invalid ApiKey!");
                } else {
                    setUiSettings(jsonResponse);
                }
            } catch (error) {
                message.error("Error fetching UI settings:", error);
                setError("Invalid ApiKey!");
            } finally {
                setLoading(false);
            }
        }

        fetchUiSettings();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            }}>
                <div className="loader"></div>
                <div style={{ marginTop: "20px" }}>Please wait. Loading...</div>
            </div>
        );
    }
    if (error) {
        return (
            <Result 
                status="403"
                title="403"
                subTitle={
                    <div className="error-message">
                        Sorry, you are not authorized to access this page. <br />
                        Error: <span>{error}</span>
                    </div>
                }
                // extra={<Button type="primary">Back Home</Button>}
            />
        );
    }
    if (uiSettings) {
        return (
            <div className="App">
                <header className="App-header">
                    <div className="logo-section">
                        <img src="https://mightyknights.us/wp-content/uploads/2024/07/imgpsh_fullsize_anim-4.png.webp" alt="logo" className="App-logo" />
                    
                    </div>

                    <p style={{
                        color: "var(--header-text)",
                        fontSize: 18,
                        fontFamily: "serif",
                        margin: "0px 10px",
                    }}>
                        {uiSettings.header?.middle ? uiSettings.header.middle : ""}
                    </p>
                    
                    <div className="button-section">
                        
                        <ThemeToggle />
                    </div>
                </header>

                <section className="App-content">
                    <Card className="card">
                        <NumberSearch uiSettings={uiSettings ?? ""} />
                    </Card>
                </section>

                <footer className="App-footer">
                    <p>© {new Date().getFullYear()} - TCPA Application</p>
                </footer>
                
                <Routes>
                    <Route path="/report-a-dnc" element={<ReportDNC />} />
                </Routes>
            </div>
        );
    }
}

export default App;